/**
 * Reduz a foto de perfil a um quadrado de 256×256 antes de enviar
 * (2026-10-15). O servidor recusa acima de 200 KB e a rede da FSB até ele
 * é lenta; reduzida, a foto fica em 10–40 KB e é baixada uma vez por
 * versão.
 *
 * Corta o CENTRO da imagem (o rosto costuma estar ali) e exporta em WebP;
 * navegador que não sabe gerar WebP devolve PNG, que o servidor também
 * aceita.
 */

export const AVATAR_SIZE = 256;

export class AvatarImageError extends Error {}

export async function squareAvatar(file: Blob): Promise<Blob> {
  let bitmap: ImageBitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    throw new AvatarImageError("Não foi possível ler esta imagem. Use JPEG, PNG ou WebP.");
  }
  const side = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement("canvas");
  canvas.width = AVATAR_SIZE;
  canvas.height = AVATAR_SIZE;
  const context = canvas.getContext("2d");
  if (!context) throw new AvatarImageError("Este navegador não consegue preparar a foto.");
  context.drawImage(
    bitmap,
    (bitmap.width - side) / 2,
    (bitmap.height - side) / 2,
    side,
    side,
    0,
    0,
    AVATAR_SIZE,
    AVATAR_SIZE
  );
  bitmap.close();
  const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, "image/webp", 0.85));
  if (!blob) throw new AvatarImageError("Este navegador não consegue preparar a foto.");
  return blob;
}
